<ag-contracts-slots-modals #slotsModals [company]="company" [user]="user"></ag-contracts-slots-modals>
<slots-modals #slotsModalsNeg [company]="company" [user]="user"></slots-modals>

<!-- Modal: Editar solicitud de cupos -->
<ng-template #editModal>
  <div class="modal-header">
    <button type="button" class="close" [disabled]="editProcessing" (click)="closeEditModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{ 'SLOTS.EDIT_REQUEST_MODAL.TITLE' | translate }}</h4>
  </div>
  <div class="modal-body" [formGroup]="editForm">
    <div class="row">
      <!-- Cantidad -->
      <div class="col-sm-4">
        <div class="form-group" [class.has-error]="editForm.get('quantity').invalid && editForm.get('quantity').dirty">
          <label class="control-label">{{ 'GLOBAL.QUANTITY' | translate }}</label>
          <input type="number" class="form-control" formControlName="quantity" min="1"
            [max]="editMaxQuantity ?? undefined" [disabled]="editProcessing">
          <span *ngIf="editMaxQuantity != null" class="help-block small text-muted">
            {{ 'SLOTS.MAX_QUANTITY' | translate }}: {{ editMaxQuantity }}
          </span>
        </div>
      </div>
      <!-- Fecha -->
      <div class="col-sm-4">
        <div class="form-group" [class.has-error]="editForm.get('date').invalid && editForm.get('date').dirty">
          <label class="control-label">{{ 'GLOBAL.DATE' | translate }}</label>
          <div class="input-group">
            <div class="input-group-addon">
              <i class="material-symbols-rounded">today</i>
            </div>
            <input type="text" formControlName="date" bsDatepicker class="form-control"
              placeholder="{{ 'GLOBAL.DATE_PLACEHOLDER' | translate }}"
              [bsConfig]="{showWeekNumbers: false, isAnimated: true, dateInputFormat: 'DD/MM/YYYY'}"
              [disabled]="editProcessing" [minDate]="today" readonly required>
          </div>
        </div>
      </div>
    </div>
    <!-- Observaciones -->
    <div class="form-group">
      <label class="control-label">
        {{ 'GLOBAL.OBSERVATIONS' | translate }}
        <small class="text-muted"> ({{ 'GLOBAL.OPTIONAL' | translate }})</small>
      </label>
      <textarea class="form-control" formControlName="observations" [disabled]="editProcessing"
        maxlength="1024" rows="3"></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" [disabled]="editProcessing" (click)="closeEditModal()">
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-agree" [disabled]="editProcessing || editForm?.invalid" (click)="submitEdit()">
      <span *ngIf="editProcessing" class="material-symbols-rounded rotating">sync</span>
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</ng-template>

<ag-view-batch-modal #viewBatchModal [company]="company"></ag-view-batch-modal>

<ng-template #loadingSpinner>
  <div class="loading" *ngIf="processing">
    <spinner message="{{ 'GLOBAL.LOADING' | translate }}"></spinner>
  </div>
</ng-template>

<ng-container *ngIf="!processing || requests !== undefined; else loadingSpinner">
  <div class="horizontal-scroller">
    <div class="table-sticky-headers" [class.tableContainer]="compact">
      <table class="table table-condensed" sortable #tableSortable="tableSortable" [variableInUrl]="true">
        <thead>
          <tr class="tr-align-center">
            <th class="sap" sortBy="date">
              {{ "GLOBAL.DATE" | translate }}
              <column-filter
                type="date"
                alignment="left"
                [dateRange]="true"
                [canDelete]="false"
                [disabledOptions]="['today', 'week', 'month', 'when', 'before', 'after']"
                [filters]="filters"
                key="filters[date]"
                (onChange)="changeFilter($event)">
              </column-filter>
            </th>
            <th class="sap" *ngIf="!compact">
              {{ "GLOBAL.CONTRACT" | translate }}
            </th>
            <th>
              {{ "SLOTS.REQUEST_SLOT_MODAL.APPLICANT" | translate }}
              <column-filter *ngIf="!predefinedFilters" type="string" alignment="left" [filters]="filters"
                key="filters[company.name]" (onChange)="changeFilter($event)">
              </column-filter>
            </th>
            <th>
              {{ "ORDER_SUMMARY.SELLER" | translate }}
            </th>
            <th class="sap">
              {{ "SLOTS.PENDING_DELIVERY_ABBR" | translate }}
            </th>
            <th *ngIf="!compact" class="text-center">
              {{ "GLOBAL.DELIVERY_PERIOD" | translate }}
            </th>
            <th>
              {{ "CPE.ACTORS.DESTINO" | translate}}
              <column-filter *ngIf="!predefinedFilters" type="string" alignment="left" [filters]="filters"
                key="filters[destination.name]" (onChange)="changeFilter($event)">
              </column-filter>
            </th>
            <th *ngIf="!compact">
              {{ "GLOBAL.PRODUCT" | translate}}
            </th>
            <th class="sap" *ngIf="!compact">
              <abbr title="{{ 'GLOBAL.OBSERVATIONS'|translate }}">{{ 'GLOBAL.OBSERVATIONS_ABBR'|translate }}</abbr>
            </th>
            <th class="sap" sortBy="quantity">
              <abbr title="{{ 'GLOBAL.QUANTITY'|translate }}">{{ "GLOBAL.QUANTITY_ABBR" | translate}}</abbr>
            </th>
            <th class="sap">
              <!-- {{ "SLOTS.TABLE_HEADER.ASSIGNED_SLOTS" | translate }} -->
            </th>
            <th class="sap" *ngIf="!compact">
              {{ "GLOBAL.STATUS" | translate }}
            </th>
            <th class="sap"></th>
            <th></th>
          </tr>
        </thead>

        <tbody *ngIf="requests?.length" class="scrollit">
          <tr class="tr-align-center" *ngFor="let item of requests"
            [class.expired-request]="item.expired"
            [class.over-limit-request]="exceedingRequestIds.has(item.id)"
            [class.returned-rejected-request]="item.isRejectedOrReturned">
            <td class="sap small">
              <date-md [date]="item.date" [style]="true">
              </date-md>
            </td>
            <td class="sap small" *ngIf="!compact">
              <a *ngIf="item.contract" [routerLink]="['/company', company.id, 'contracts', item.contract.id]">
                <samp>#{{ item.contract.reference }}</samp>
              </a>
              <a *ngIf="item.negotiation" [routerLink]="['/company', company.id, 'counter-order', item.negotiation.id]">
                <samp>#{{ item.negotiation.id }}</samp>
              </a>
            </td>
            <td>
              <company-info [company]="item.company" [compact]="compact" [activity]="false"></company-info>
            </td>
            <td>
              <company-info [company]="item.contract?.seller || item.negotiation?.seller" [compact]="compact" [activity]="false"></company-info>
            </td>
            <td class="sap text-right small">
              <ng-container *ngIf="item.contract || item.negotiation">
                <!-- PAF: TN Fijadas - TN Entregadas -->
                <ng-container *ngIf="item.contract?.price?.type === 'to_be_fixed'">
                  <!-- PAF ≠ 0: mostrar fórmula PAF (TN Fijadas - TN Entregadas) -->
                  <span *ngIf="((item.contract.summary?.fixed_volume?.value || 0) - (item.contract.applied?.value || 0)) !== 0"
                        tooltip="{{ 'SLOTS.PENDING_DELIVERY_TOOLTIP_PAF' | translate }}" placement="left">
                    {{ ((item.contract.summary?.fixed_volume?.value || 0) - (item.contract.applied?.value || 0)) | number:'1.0-2' }}
                    {{ item.contract.quantity?.unit?.abbrev }}
                  </span>
                  <!-- PAF = 0 sin fijaciones: mostrar pendiente total (quantity - applied) -->
                  <span *ngIf="((item.contract.summary?.fixed_volume?.value || 0) - (item.contract.applied?.value || 0)) === 0 && !(item.contract.summary?.fixed_volume?.value)"
                        [class.text-warning]="((item.contract.quantity?.value || 0) - (item.contract.applied?.value || 0)) > 0"
                        tooltip="{{ 'SLOTS.PENDING_DELIVERY_TOOLTIP_PAF_ZERO' | translate }}" placement="left">
                    {{ ((item.contract.quantity?.value || 0) - (item.contract.applied?.value || 0)) | number:'1.0-2' }}
                    {{ item.contract.quantity?.unit?.abbrev }}
                  </span>
                  <!-- PAF = 0 con fijaciones: todo lo fijado ya fue entregado -->
                  <span *ngIf="((item.contract.summary?.fixed_volume?.value || 0) - (item.contract.applied?.value || 0)) === 0 && (item.contract.summary?.fixed_volume?.value)"
                        class="text-muted"
                        tooltip="{{ 'SLOTS.PENDING_DELIVERY_TOOLTIP_PAF_DELIVERED' | translate }}" placement="left">
                    0 {{ item.contract.quantity?.unit?.abbrev }}
                  </span>
                </ng-container>
                <!-- PH: Pendiente de entrega -->
                <ng-container *ngIf="item.contract?.price?.type !== 'to_be_fixed'">
                  <!-- Sobre-entrega: se entregó más de lo pactado -->
                  <span *ngIf="((item.contract?.quantity?.value || 0) - (item.contract?.applied?.value || 0)) < 0"
                        class="text-success"
                        tooltip="{{ 'SLOTS.PENDING_DELIVERY_TOOLTIP_OVER' | translate }}" placement="left">
                    <span class="material-symbols-rounded small">arrow_upward</span>
                    {{ ((item.contract?.applied?.value || 0) - (item.contract?.quantity?.value || 0)) | number:'1.0-2' }}
                    {{ item.contract?.quantity?.unit?.abbrev }}
                  </span>
                  <!-- Pendiente normal -->
                  <span *ngIf="((item.contract?.quantity?.value || 0) - (item.contract?.applied?.value || 0)) >= 0"
                        tooltip="{{ 'SLOTS.PENDING_DELIVERY_TOOLTIP_PH' | translate }}" placement="left">
                    {{ ((item.contract?.quantity?.value || 0) - (item.contract?.applied?.value || 0)) | number:'1.0-2' }}
                    {{ item.contract?.quantity?.unit?.abbrev }}
                  </span>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!item.contract && !item.negotiation">
                <span class="text-muted">&#8212;</span>
              </ng-container>
            </td>
            <td *ngIf="!compact" class="small text-muted">
              <date-range
                [from]="item.contract?.delivery?.date_from"
                [to]="item.contract?.delivery?.date_to"></date-range>
            </td>
            <td class="small text-muted">
              {{ (item.contract?.delivery?.locations || item.negotiation?.proposal.business_detail.delivery?.locations)
              | locationString | titlecase }}
            </td>
            <td *ngIf="!compact">
              {{ item.contract?.product?.name || item.negotiation?.order?.product?.name }}
            </td>
            <td class="sap text-center" *ngIf="!compact">
              <i tooltip="{{ item.observations }}" placement="right" class="text-muted material-symbols-rounded"
                *ngIf="item.observations">comment</i>
            </td>
            <td>
              <samp class="slots snum dlb hidden-xs">{{item.quantity}}</samp>
              <i *ngIf="exceedingRequestIds.has(item.id)"
                class="material-symbols-rounded text-warning over-limit-icon"
                tooltip="{{ 'SLOTS.CONTRACT_CUPOS_EXCEEDED_ROW'|translate }}"
                placement="left">warning</i>
            </td>
            <td class="sap">
              <progress-circle
                [label]="('SLOTS.ASSIGNED'|translate) + ': ' + item.assignedQuantity"
                [rejectedLabel]="item.hasRejected ? ('SLOTS.STATUS.REJECTED'|translate) + ': ' + item.effectiveRejectedCount : ''"
                [returnedLabel]="item.returnedQuantity > 0 ? ('SLOTS.STATUS.RETURNED'|translate) + ': ' + item.returnedQuantity : ''"
                [progress]="item.assignedPercentage"
                [rejected]="item.rejectedPercentage"
                [returned]="item.returnedPercentage"
                [showLegend]="false">
              </progress-circle>
            </td>
            <!-- Status label -->
            <td class="sap" *ngIf="!compact"
              [ngClass]="getItemStatusClass(item)">
              {{ getStatusLabel(item) | translate }}
              <div *ngIf="item.created_at" class="micro text-muted">
                {{ 'FINTECH.REQUESTED'|translate }}:
                <ag-timestamp [date]="item.created_at" [inline]="true"></ag-timestamp>
              </div>
            </td>
            <td class="sap">
              <div *ngIf="item.batches?.length" class="btn-group" dropdown placement="bottom right">
                <button dropdownToggle type="button" class="btn btn-link dropdown-toggle">
                  <span class="material-symbols-rounded small">local_shipping</span>
                </button>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                  <li *ngFor="let batch of item.batches">
                    <a class="dropdown-item" (click)="viewBatchModal.showBatch(batch)">
                      {{ batch.slots_total }} <span class="material-symbols-rounded faded">arrow_right</span> {{
                      batch.destination.company.name }}
                    </a>
                  </li>
                </ul>
              </div>
            </td>
            <!-- Status Action buttons -->
            <td class="sap">
              <div class="btn-group">
                <!-- Asignar -->
                <button *ngIf="canAccept(item) && item.contract" type="button" [disabled]="readonlyUser"
                  (click)="slotsModals.assignBatchToContract(item.contract, item)" class="btn btn-agree">
                  {{ 'SLOTS.ASSIGN'|translate }}
                </button>
                <button *ngIf="canAccept(item) && !item.contract" type="button" [disabled]="readonlyUser"
                  (click)="slotsModalsNeg.assignBatchToNegotiation(item.negotiation, item)" class="btn btn-agree">
                  {{ 'SLOTS.ASSIGN'|translate }}
                </button>
                <!-- Rechazar -->
                <button *ngIf="canReject(item)" type="button" [disabled]="readonlyUser" class="btn btn-danger"
                  (onConfirm)="reject($event, item)" [confirm-options]="{
                    title: 'SLOTS.REJECT_REQUEST_MODAL.TITLE'|translate,
                    body: 'SLOTS.REJECT_REQUEST_MODAL.DESCRIPTION'|translate,
                    action: 'GLOBAL.YES_REJECT'|translate,
                    observations: ''}">
                  {{ 'GLOBAL.REJECT'|translate }}
                </button>
                <!-- Retirar -->
                <button *ngIf="canRetire(item)" type="button" class="btn btn-warning" [disabled]="readonlyUser"
                  (onConfirm)="retire($event, item)" [confirm-options]="{
                    title: 'SLOTS.WITHDRAW_REQUEST_MODAL.TITLE'|translate,
                    body: 'SLOTS.WITHDRAW_REQUEST_MODAL.DESCRIPTION'|translate,
                    action: 'GLOBAL.YES_WITHDRAW'|translate,
                    observations: ''}">
                  {{ 'GLOBAL.WITHDRAW'|translate }} <span class="material-symbols-rounded">undo</span>
                </button>
                <!-- Editar -->
                <button *ngIf="canEdit(item)" type="button" class="btn btn-default" [disabled]="readonlyUser"
                  (click)="openEditModal(item)">
                  <span class="material-symbols-rounded">edit</span>
                </button>
                <!-- Borrar -->
                <button *ngIf="canDelete(item)" type="button" class="btn btn-danger" [disabled]="readonlyUser"
                  (onConfirm)="delete($event, item)" [confirm-options]="{
                  title: 'SLOTS.DELETE_REQUEST_MODAL.TITLE'|translate,
                  action: 'GLOBAL.YES_DELETE'|translate,
                  observations: ''}">
                  <span class="material-symbols-rounded">delete</span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>

      </table>
    </div>
    <!-- No data -->
    <div *ngIf="!requests?.length" class="no-data">
      <i class="material-symbols-rounded">block</i>
      {{ 'GLOBAL.NO_DATA'|translate }}
    </div>
  </div>
</ng-container>